
(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, ) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.PreviewCustomSubjects = this.HyperMD.PreviewCustomSubjects || {}), );
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CustomSubjects = void 0;
    var CustomSubjects;
    (function (CustomSubjects) {
        CustomSubjects[CustomSubjects["pagebreak"] = 0] = "pagebreak";
        CustomSubjects[CustomSubjects["newpage"] = 1] = "newpage";
        CustomSubjects[CustomSubjects["toc"] = 2] = "toc";
        CustomSubjects[CustomSubjects["tocstop"] = 3] = "tocstop";
        CustomSubjects[CustomSubjects["slide"] = 4] = "slide";
        CustomSubjects[CustomSubjects[".slide"] = 5] = ".slide";
        CustomSubjects[CustomSubjects[".slide:"] = 6] = ".slide:";
        CustomSubjects[CustomSubjects["ebook"] = 7] = "ebook";
        CustomSubjects[CustomSubjects["toc-bracket"] = 8] = "toc-bracket";
    })(CustomSubjects = exports.CustomSubjects || (exports.CustomSubjects = {}));
});
